module.exports = __webpack_public_path__ + "static/media/email-bg.b4e981c8.jpg";